export type EntityType =
	| 'zone'
	| 'room'
	| 'load'
	| 'rcu'
	| 'din'
	| 'keypad'
	| 'scene'
	| 'product'
	| 'led-logic'
	| 'browse-loads'
	| 'products'
	| null;

export type RouteEntity = { type: EntityType; id: number | null };

/** @deprecated Use RouteEntity */
export type SelectedEntity = RouteEntity;

export const EMPTY_ENTITY: RouteEntity = { type: null, id: null };

export type Route =
	| { name: 'dashboard' }
	| { name: 'guide' }
	| { name: 'admin-users' }
	| { name: 'project'; projectId: number }
	| { name: 'unit'; unitId: number; entity: RouteEntity | null };

export type RouteLayout = 'main' | 'workspace';

export type RouteView = Route['name'];
